import type { NetworkComponent, PowerUpKind } from '../types';

export const LESSONS: Record<NetworkComponent, string> = {
  device: 'Your device creates the message that needs to travel.',
  router: 'The router directs information to the right destination.',
  switch: 'A switch connects devices inside the same network.',
  cable: 'Ethernet cables carry data through fast, reliable connections.',
  internet: 'The internet connects networks across communities and the world.',
  firewall: 'A firewall helps block unsafe traffic.',
  server: 'A server stores information and provides services.',
};

export const POWER_UP_LABELS: Record<PowerUpKind, { name: string; cue: string }> = {
  'firewall-shield': { name: 'Firewall Shield', cue: 'Shield active: one malware hit blocked.' },
  'bandwidth-boost': { name: 'Bandwidth Boost', cue: 'Bandwidth boosted: packet speed increased.' },
  'wifi-extender': { name: 'Wi-Fi Extender', cue: 'Shortcut open: look for the antenna bridge.' },
  'tech-support': { name: 'Tech Support', cue: 'Hazards paused: tech support is on the case.' },
  encryption: { name: 'Encryption Mode', cue: 'Encrypted: malware cannot see Pax.' },
};

export const NETWORK_FACTS = [
  'Routers choose paths so packets can reach the right network.',
  'Switches connect computers, cameras, and phones on one local network.',
  'Firewalls inspect traffic and help block unsafe connections.',
  'Wi-Fi uses radio waves; Ethernet travels through a physical cable.',
  'Servers answer requests from devices and provide useful services.',
];

export const OBJECTIVES: Record<NetworkComponent, string> = {
  device: 'LAUNCH THE PACKET',
  router: 'FIND THE ROUTER',
  switch: 'CONNECT THE SWITCH',
  cable: 'SECURE THE CABLE',
  internet: 'ENTER THE INTERNET',
  firewall: 'ACTIVATE THE FIREWALL',
  server: 'REACH THE SERVER',
};
